import { Navigate, useLocation} from 'react-router-dom';

const PrivateRoutes = (props) => {

    const { status, children } = props
    // console.log('PrivateRoutes ----- ', status)

    const { pathname } = useLocation();
    const lastPath = pathname;
    localStorage.setItem('lastPath', lastPath );

    return (status === 'authenticated' || status === 'checking' )
        ? children
        : <Navigate to="/auth/login" />
}

export {
    PrivateRoutes
}